
import { Options, Vue } from 'vue-class-component';
import LoadingScreen from '@/components/LoadingScreen.vue';

type ButtonAppearance = 'primary' | 'secondary';

@Options({
  components: {
    LoadingScreen
  },
  props: {
    appearance: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonClass: {
      type: String,
      required: false,
      default: ''
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
export default class Button extends Vue {
  appearance: ButtonAppearance;
  buttonClass: string;
  isLoading: boolean;

  get appearanceClasses() {
    switch (this.appearance) {
      case 'secondary':
        return 'm-button--secondary';
      case 'primary':
      default:
        return 'm-button--primary';
    }
  }

  get disabled(): boolean {
    return this.isLoading || this.disabled;
  }
}
